import React from "react";
import { Mui } from "@osu/react-ui";

export default function LightbulbIcon(props) {
    return (
        <Mui.SvgIcon {...props}>
            <path d="M10.5,0 C4.704,0 0,4.704 0,10.5 C0,16.296 4.704,21 10.5,21 C16.296,21 21,16.296 21,10.5 C21,4.704 16.296,0 10.5,0 Z M10.5,17.85 C9.6285,17.85 8.925,17.1465 8.925,16.275 L12.075,16.275 C12.075,17.1465 11.3715,17.85 10.5,17.85 Z M13.65,15.225 L7.35,15.225 L7.35,13.65 L13.65,13.65 L13.65,15.225 Z M13.6185,12.6 L7.3815,12.6 C6.09,11.6445 5.25,10.122 5.25,8.4 C5.25,5.502 7.602,3.15 10.5,3.15 C13.398,3.15 15.75,5.502 15.75,8.4 C15.75,10.122 14.91,11.6445 13.6185,12.6 Z" id="Shape" />
        </Mui.SvgIcon>
    );
}